import type { FaireProductEntity } from "../../entity_types/product";

export const p_9pejpunmd3: FaireProductEntity = {
  token: "p_9pejpunmd3",
  type: "product",
  name: "Me To You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4f7c49f45376b3eeb28c9a103a716af881686787d816a63bda2623282c78bb9f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa942857d66e5bc4b8634ca75fcc2cbdc2554b0af4317f9d91d6376e51fbbc2c.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:03.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
